const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:3000",
  featureFlag: process.env.REACT_APP_FEATURE_FLAG === "true",
  environment: process.env.NODE_ENV || "development",
  applicationTitle: "VIP出租车",
  telegramUrl: "https://t.me/TaxiVIP24h",
};

export default config;
